<app-theader></app-theader>
<div class="row mainrow">
	<div class="col-sm-2"></div>
	<div class="col-sm-8 rightdiv">
		<div class="rightinnerdiv">
		<form #d="ngForm" (ngSubmit)="registerFinzy(d.value)" (keydown.enter)="$event.preventDefault()">
			<p class="headtxt">Register</p>

			<p class="txt1">Name as on PAN card</p>
			<mat-form-field style="width: 100%">
			  <input matInput  placeholder="" maxlength="30" [(ngModel)]="name" name="name" type="text" required autocomplete="off" (keyup)="onNameInput($event)">
			</mat-form-field>

			<p class="txt1">Mobile number</p>
			<mat-form-field style="width: 100%">
				<span matPrefix>+91&nbsp;</span>
			  <input matInput  placeholder="" maxlength="10" [(ngModel)]="phoneno" name="phoneno" type="text" required autocomplete="off" (keyup)="onPhoneInput($event)">
			</mat-form-field>
			<span class="errormsg" *ngIf="mobileError">{{mobileErrorMsg}}</span>
			
			<p class="txt1">Email</p>
			<mat-form-field style="width: 100%">
				<input matInput  name="email" title="Please provide a valid email" required [(ngModel)]="email" maxlength="64" type="email" placeholder="We only use this for relevant updates and information">
			</mat-form-field>

			<span class="errormsg" *ngIf="errorEmailRange">Please enter a valid email ID</span>
			
			<p class="txt1">Loan amount</p>
			<mat-form-field style="width: 100%">
			  <input matInput  placeholder="" [(ngModel)]="loan_amt" name="loan_amt" type="text" required autocomplete="off">
			</mat-form-field>
			<span class="errormsg" *ngIf="errorMsgRange">Loan amount should be between Rs 50,000 and Rs 5,00,000</span>
			<span class="errormsg" *ngIf="errorMsgRange2">Loan amount should in multiples Rs 1,000</span>

			<p class="txt1">Loan purpose</p>
			<mat-form-field style="width: 100%">
			  <input matInput  placeholder="" [readonly]="true" value="Travel/Holiday" type="text" autocomplete="off">
			</mat-form-field>

			<button mat-flat-button class="primary" type="submit">REGISTER</button>
		</form>
			
		</div>	
	</div>
	<div class="col-sm-2"></div>
</div>


<app-tfooter></app-tfooter>